import {UDICEProvider} from './udice-connect-providers.js';
import {UDICESession} from "./udice-connect-session.js";
import * as UDICEConfig from './udice.config.ts';
import {UDICEDialog} from "./udice-app-utils.ts";
import { Contract, ContractAbi, Web3EthInterface } from 'web3';

export const ON_SESSION_CHANGED_EVENT_ID = "ON_SESSION_CHANGED_EVENT_ID";

export interface AuthenticatorOptions{
    hideChainsWithNoContract?: boolean,
    enableChainsWithNoContract?: boolean
}

export class UDICEApplicationAuthenticator extends HTMLElement{
        
    private _connectButton: HTMLButtonElement;
    private _session: UDICESession | null | undefined;
    private _disconnectButton: HTMLButtonElement;

    constructor(){
        super();
        this.innerHTML = `
            <div class="d-grid0 gap-20 clearfix">
                <button class="w-100 btn btn-danger btn-lg">
                    <!--Metamask -->
                    <img src="data:image/svg+xml;base64,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" width="30" height="24">
                    <!--Brave wallet -->
                    <img src="data:image/png;base64,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" width="30" height="24">
                    <!--Trust wallet -->
                    <!--
                    <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNjUiIHZpZXdCb3g9IjAgMCA1OCA2NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgOS4zODk0OUwyOC44OTA3IDBWNjUuMDA0MkM4LjI1NDUgNTYuMzM2OSAwIDM5LjcyNDggMCAzMC4zMzUzVjkuMzg5NDlaIiBmaWxsPSIjMDUwMEZGIi8+CjxwYXRoIGQ9Ik01Ny43ODIyIDkuMzg5NDlMMjguODkxNSAwVjY1LjAwNDJDNDkuNTI3NyA1Ni4zMzY5IDU3Ljc4MjIgMzkuNzI0OCA1Ny43ODIyIDMwLjMzNTNWOS4zODk0OVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yMjAxXzY5NDIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjIwMV82OTQyIiB4MT0iNTEuMzYxNSIgeTE9Ii00LjE1MjkzIiB4Mj0iMjkuNTM4NCIgeTI9IjY0LjUxNDciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjAyMTEyIiBzdG9wLWNvbG9yPSIjMDAwMEZGIi8+CjxzdG9wIG9mZnNldD0iMC4wNzYyNDIzIiBzdG9wLWNvbG9yPSIjMDA5NEZGIi8+CjxzdG9wIG9mZnNldD0iMC4xNjMwODkiIHN0b3AtY29sb3I9IiM0OEZGOTEiLz4KPHN0b3Agb2Zmc2V0PSIwLjQyMDA0OSIgc3RvcC1jb2xvcj0iIzAwOTRGRiIvPgo8c3RvcCBvZmZzZXQ9IjAuNjgyODg2IiBzdG9wLWNvbG9yPSIjMDAzOEZGIi8+CjxzdG9wIG9mZnNldD0iMC45MDI0NjUiIHN0b3AtY29sb3I9IiMwNTAwRkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K" width="30" height="24">
                    -->
                    Connect <i class="bi bi-box-arrow-in-right"></i>
                </button>
                <button class="btn float-end"><i class="bi bi-power"></i></button>
            </div>
        `;
        this._connectButton = this.querySelector("button.btn-lg") as HTMLButtonElement;
        this._connectButton.addEventListener("click", e=>{
            if(this.session!=null){
                //this.switch();
                this.session = null;
            }else{
                this._connectButton.disabled = true;
                this.connect()
                    .finally(()=>{
                        this._connectButton.disabled = false;
                    });
            }
        });
        this._disconnectButton = this.querySelector("button.float-end") as HTMLButtonElement;
        this._disconnectButton.addEventListener("click", e=>{
            this.session = null;
        })
        this.session = null;
    }

    get session(){
        return this._session;
    }
    set session(value){
        if(this._session!=null){
            this._session.close();
        }
        this._session = value;
        if(this._session!=null){
            //this._connectButton.innerHTML = `<i class="bi bi-box-arrow-left"></i> ${this._session.chainInfo.name}`;
            this._connectButton.classList.add("d-none");
            this._disconnectButton.classList.remove("d-none");
            this._session.addInvalidationListener(()=>{
                if(this.session==value){
                    this.session = undefined;
                }
            });
        }else{
            //this._connectButton.innerHTML = `Connect <i class="bi bi-box-arrow-in-right"></i>`;
            this._connectButton.classList.remove("d-none");
            this._disconnectButton.classList.add("d-none");
        }
        this.dispatchEvent(new CustomEvent(ON_SESSION_CHANGED_EVENT_ID, {bubbles: true, detail: value}))
    }

    static createChainEntry(contractInfo: UDICEConfig.UdiceContractInfo, options?:AuthenticatorOptions){
        let button = document.createElement("button");
        button.classList.add(/*'btn', 'btn-primary',*/ 'list-group-item');
        
        let enableChainsWithNoContract: boolean = options!=null && options.enableChainsWithNoContract;

        if(contractInfo.contractAddress==null || contractInfo.contractAddress.length==0 /*|| chainInfo.launchTime.getTime() > Date.now()*/){
            button.disabled = !enableChainsWithNoContract;
            button.innerHTML = `
            <img src="${contractInfo.iconUrl}" width="48" height="48" ${contractInfo.testnet?' style="filter: grayscale(1);"':''}></img>    
                ${contractInfo.displayName} <i class="bi bi-rocket"></i>
            `;
        }else{
            button.innerHTML = `
            <img src="${contractInfo.iconUrl}" width="48" height="48" ${contractInfo.testnet?' style="filter: grayscale(1);"':''}></img>    
            ${contractInfo.displayName} 🚀 <i class="bi bi-rocket-takeoff"></i> &rarr;
        `;
        }
        return button;
    }

    static async promptChainAdd(udiceProvider : UDICEProvider, targetChainId:number){
        return udiceProvider.provider.request({
            method: 'wallet_addEthereumChain',
            params: [UDICEConfig.getAddEthereumChainParameter(targetChainId)]
        });
    }

    static async promptChainSwitch(udiceProvider : UDICEProvider, targetChainId : number){
        let chain = UDICEConfig.getAddEthereumChainParameter(targetChainId);
        return udiceProvider.provider.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: chain.chainId}],
          }).then(async result=>{
                let currentChainId : BigInt = await udiceProvider.getChainId();
                if(BigInt(targetChainId)!=currentChainId){
                    throw new Error("Expected switch to chain "+targetChainId+", but got "+currentChainId);
                }
                return {"chainId": targetChainId, chain};
            }).catch(async (error)=>{
                if(error?.code==4902 || error?.data?.originalError?.code==4902){
                    return this.promptChainAdd(udiceProvider, targetChainId);
                }
                return Promise.reject(error);
            });
    }

    async connect(){
        let result:Promise<UDICESession> = startContractSelectionFlow().then(async contractSelectionResult=>{
            let provider = contractSelectionResult.provider;
            let accounts = await provider.getAccounts();
            let account = accounts[0];
            let contractInfo = contractSelectionResult.contract;
    
            let newSession = new UDICESession(provider, contractInfo, account);
            this.session = newSession;
            return newSession;
        })
        return result.catch(error=>{
            console.error(error);
            if(error instanceof ContractSelectionFlowError){
                return this.handleContractSelectionFlowError(error);
            }
            if(error.code==4001){
                return null;
            }
            if(error.message!=null){
                alert(error.message);
                return null;
            }
            alert(JSON.stringify(error));
            console.error(JSON.stringify(error));
        });;
    }

    handleContractSelectionFlowError(error: ContractSelectionFlowError) {
        switch(error.code){
            case ContractSelectionFlowErrorCode.NO_PROVIDER:
                if(window.navigator['brave'] && window.navigator['brave'].isBrave!=null && window.navigator['brave'].isBrave()){
                    window.open("https://brave.com/wallet/");
                }else{
                    window.open('https://metamask.io/download/', '_blank');
                }
                break;
            case ContractSelectionFlowErrorCode.USER_CANCELLED:
                break;
            case ContractSelectionFlowErrorCode.NO_SUPPORTED_CHAIN:
                window.alert("No suported chain");
                break;
            case ContractSelectionFlowErrorCode.NO_CONTRACT_ON_THIS_CHAIN:
                window.alert("No contract on the selected chain");
                break;
        }
        return null;
    }

    switch(){
        return this.connect();
    }


}
customElements.define('udice-application-authenticator', UDICEApplicationAuthenticator);

/*
class ProviderSelectionFactory extends HTMLElement{

    static async promptProviderSelection() : Promise<UDICEProvider>{
        let providers = await UDICEProvider.listUDICEProviders();
        if(providers.length==0){
            throw new Error("Please install metamask");
        }
        if(providers.length==1){
            return providers[0];
        }else{
            let dialog: UDICEDialog = new UDICEDialog();
            let result = Promise.withResolvers<UDICEProvider>();
            //TODO: show providers list dialog 
            let buttons: HTMLElement[] = providers.map(provider=>{
                let button = document.createElement("button");
                button.classList.add('btn', 'btn-primary', 'list-group-item');
                button.innerHTML = `
                <img src='${provider.icon}' width='30' height='24'></img>
                ${provider.name}
                `;
                button.addEventListener("click", e=>{
                    result.resolve(provider);
                    dialog.close();
                });
                return button;
            });
            let container = document.createElement("div");
            container.classList.add('list-group', 'align-middle', 'mt-1', 'col-lg-4', 'col-md-6');
            buttons.forEach(button=>container.appendChild(button));

            dialog.titleContent = "Select Your Favourate Chain";
            dialog.bodyContent = container;
            dialog.show();
            dialog.onClosed = ()=>{
                result.reject(new Error("Cancelled"));  
            };
            return result.promise;

            //throw new Error("//TODO: show providers list dialog ");
            
        }
    }

    constructor(){
        super();
    }
}

class ChainSelectionFactory extends HTMLElement{
    static async promptChain(provider : UDICEProvider, options?:AuthenticatorOptions): Promise<UDICEConfig.UdiceContractInfo | null>{
        let dialog: UDICEDialog = new UDICEDialog();

        //let chainIds = Object.keys(UDICEConfig.chains);
        let container = document.createElement("div");
        container.classList.add('list-group', 'align-middle', 'mt-1', 'col-lg-4', 'col-md-6');
        
        //let dialog: HTMLDialogElement = document.createElement("dialog");
        //dialog.classList.add("border", "border-2", "rounded", "rounded-4")
        //dialog.appendChild(container);
        //(document.querySelector("body") as HTMLElement).appendChild(dialog);
        let result = Promise.withResolvers<UDICEConfig.UdiceContractInfo>();

        let contracts = UDICEConfig.ContractsRegistry.getInstance().list();

        if(contracts.length==1){
            result.resolve(contracts[0]);
            return result.promise;
        }

        contracts.forEach(contractInfo=>{
            let hideChainsWithNoContract = options!=null && options.hideChainsWithNoContract;

            if(hideChainsWithNoContract && contractInfo.contractAddress==null || contractInfo.contractAddress==""){
                return;
            }
            let button = UDICEApplicationAuthenticator.createChainEntry(contractInfo, options);

            button.addEventListener("click", e=>{
                result.resolve(contractInfo);
                dialog.close();
            });
            container.appendChild(button);
        });

        dialog.titleContent = "Select Your Favorite Chain";
        dialog.bodyContent = container;
        dialog.show();
        dialog.onHidden = ()=>{
            result.reject(new Error("Cancelled"));  
        };
        return result.promise;
    }
}
*/

interface SelectedContract{
    provider : UDICEProvider;
    chainId: number;
    contract: UDICEConfig.UdiceContractInfo;
}
class SelectionError extends Error{

}

async function showConcentDialog(): Promise<void>{
    if(window.localStorage.getItem("udice-app-authenticator-concent-granted")=="1"){
        return null;
    }
    let result = Promise.withResolvers<void>();
    let okButton = document.createElement("button");
    okButton.classList.add("btn", "btn-primary")
    okButton.innerHTML = `Confirm`;
    okButton.disabled = true;
    okButton.addEventListener("click", e=>result.resolve(null));
    
    let container = document.createElement("div");
    container.innerHTML = `
    <p>
    It is prohibited to access or use our services if you are located, incorporated or otherwise established in, or a citizen or resident of or been a citizen of U.S., Quebec(Canada), Singapore, Cuba, Crimea, Sevastopol, Iran, Syria, North Korea, Sudan and Mainland China.
    </p>
    <p>
    Use of a virtual private network (e.g., a vpn) to use our services as a restricted person from a restricted territory is prohibited.    
    </p>
    <input type="checkbox" id="concent-checkbox"> 
    <label for="concent-checkbox" class="bg-danger">I have read and agreed to the above content</label>
    `;
    /*
    container.innerHTML = `
    
    <input type="checkbox" id="concent-checkbox"> 
    <label for="concent-checkbox" class="bg-danger">I confirm that I am not from a prohibited jurisdiction and I am eligible to gamble on this platform.</label>
    `;
    */
   
    let checkBox = container.querySelector("input[type=checkbox]");
    checkBox.addEventListener("click", e=>okButton.disabled=!okButton.disabled)
    let dialog: UDICEDialog = new UDICEDialog();
    dialog.titleContent = "Notice";
    dialog.bodyContent = container;
    dialog.footerAppendableContent = okButton;
    dialog.fullscreen = false;
    dialog.show();
    dialog.onClosed = ()=>{
        result.reject("Cancelled");
    };
    return result.promise.then(()=>{
        window.localStorage.setItem("udice-app-authenticator-concent-granted", "1");
        dialog.close();
    });
}

enum ContractSelectionFlowErrorCode {NO_PROVIDER, USER_CANCELLED, NO_SUPPORTED_CHAIN, NO_CONTRACT_ON_THIS_CHAIN}

class ContractSelectionFlowError extends Error{
    
    readonly code: ContractSelectionFlowErrorCode;

    constructor(code: ContractSelectionFlowErrorCode){
        super();
        this.code = code;
    }
}

async function selectContract(provider: UDICEProvider, chain: UDICEConfig.ChainInfo): Promise<SelectedContract> {
    let contracts = UDICEConfig.ContractsRegistry.getInstance().list().filter(contract => contract.chain.chainId == chain.chainId);
    if (contracts.length == 0) {
        throw new ContractSelectionFlowError(ContractSelectionFlowErrorCode.NO_CONTRACT_ON_THIS_CHAIN);
    } else if (contracts.length == 1) {
        return { provider: provider, chainId: chain.chainId, contract: contracts[0] };
    } else {
        return showContractSelectionDialog(provider, chain, contracts);
    }
}

async function showContractSelectionDialog(provider: UDICEProvider, chain: UDICEConfig.ChainInfo, contracts: UDICEConfig.UdiceContractInfo[]): Promise<SelectedContract> {
    let result = Promise.withResolvers<SelectedContract>();
    let buttons = contracts.map(contract => {
        let button = document.createElement("button");
        button.classList.add('btn', 'btn-primary', 'list-group-item');
        button.innerHTML = `<img src='' width='30' height='24'></img> ${contract.displayName} 
                <span class="badge">${contract.contractAddress}</span>
            `;

        if (contract.created != null) {
            button.innerHTML += `<span class='badge bg-danger'>created ${contract.created.toISOString()}</span>`;
        }
        if (contract.launchTime != null) {
            button.innerHTML += `<span class='badge bg-danger'>starting ${contract.launchTime.toISOString()}</span>`;
        }
        button.addEventListener("click", e => {
            result.resolve({ provider: provider, chainId: chain.chainId, contract: contract });
        });
        button.querySelector("img").src = contract.iconUrl;
        if (chain.testnet) {
            button.style.filter = "grayscale(1)";
        }
        return button;
    });
    showSelectionDialog(`Select contract: ${chain.name} (${chain.nativeCurrency.symbol})`, buttons, () => result.reject(new ContractSelectionFlowError(ContractSelectionFlowErrorCode.USER_CANCELLED)));
    return result.promise;
}

async function selectChain(provider: UDICEProvider): Promise<UDICEConfig.ChainInfo> {
    let chains = new Map<number, UDICEConfig.ChainInfo>();
    UDICEConfig.ContractsRegistry.getInstance().list().forEach((value, index, array) => {
        if (chains.has(value.chain.chainId)) {
            return;
        }
        chains.set(value.chain.chainId, value.chain);
    });
    let chainsArray = Array.from(chains).map(item => item[1]);
    if (chainsArray.length == 0) {
        //throw new Error("No supported chain available");
        throw new ContractSelectionFlowError(ContractSelectionFlowErrorCode.NO_SUPPORTED_CHAIN);
    } else if (chainsArray.length == 1) {
        return chainsArray[0];
    } else {
        return showChainSelectionDialog(provider, chainsArray);
    }
}

async function showChainSelectionDialog(provider: UDICEProvider, chains: UDICEConfig.ChainInfo[]): Promise<UDICEConfig.ChainInfo> {
    let result = Promise.withResolvers<UDICEConfig.ChainInfo>();
    let buttons = chains.map(chain => {
        let button = document.createElement("button");
        button.classList.add('btn', 'btn-primary', 'list-group-item');
        button.innerHTML = `<img src='' width='30' height='24'></img> ${chain.name}`;
        button.addEventListener("click", e => {
            result.resolve(chain);
        });
        button.querySelector("img").src = chain.icon;
        if (chain.testnet) {
            button.style.filter = "grayscale(1)";
        }
        return button;
    });
    showSelectionDialog("Select your favourate ❤️ chain", buttons, () => result.reject(new ContractSelectionFlowError(ContractSelectionFlowErrorCode.USER_CANCELLED)));
    return result.promise;
}

async function selectProvider(): Promise<UDICEProvider> {
    let providers = await UDICEProvider.listUDICEProviders();

    if (providers.length == 0) {
        throw new ContractSelectionFlowError(ContractSelectionFlowErrorCode.NO_PROVIDER);
    } else if (providers.length == 1) {
        return providers[0];
    } else {
        return showProviderSelectionDialog(providers);
    }
}

async function showProviderSelectionDialog(providers: UDICEProvider[]): Promise<UDICEProvider> {
    let result = Promise.withResolvers<UDICEProvider>();
    let buttons = providers.map(provider => {
        let button = document.createElement("button");
        button.classList.add('btn', 'btn-primary', 'list-group-item');
        button.innerHTML = `<img src='' width='30' height='24'></img> ${provider.name}`;
        button.addEventListener("click", e => {
            result.resolve(provider);
        });
        button.querySelector("img").src = provider.icon;
        return button;
    });
    showSelectionDialog("Select provider", buttons, () => result.reject(new ContractSelectionFlowError(ContractSelectionFlowErrorCode.USER_CANCELLED)));
    return result.promise;
}

async function startContractSelectionFlow(): Promise<SelectedContract> {
    //await showConcentDialog();
    let provider = await selectProvider();
    let chain = await selectChain(provider);
    let result = await selectContract(provider, chain);
    if (BigInt(chain.chainId) != await provider.getChainId()) {
        await UDICEApplicationAuthenticator.promptChainSwitch(provider, chain.chainId);
    }
    return result;
}

function showSelectionDialog(title: string, buttons: HTMLButtonElement[], onClosed: () => void): UDICEDialog {
    let container = document.createElement("div");
    container.classList.add('list-group', 'align-middle', 'mt-1', 'col-lg-4', 'col-md-6');
    buttons.forEach(button => container.appendChild(button));

    let dialog: UDICEDialog = new UDICEDialog();
    dialog.titleContent = title;
    dialog.bodyContent = container;
    dialog.show();
    dialog.onClosed = onClosed;
    buttons.forEach(button => button.addEventListener("click", e => { dialog.close() }))
    return dialog;
}
